import React from 'react';

import classes from './styles.module.scss';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import emptyFolderIcon from '../../../assets/images/my-library/emptyFolder.svg';

export default function EmptyFolderMessage({ message = 'This folder is empty' }) {
  const isMobile = useCheckMobileScreen();

  if (!isMobile) {
    return (
      <div className={classes.EmptyFolderMessageDesktop}>
        <div className={classes.emptyFolderIconContainer}>
          <img src={emptyFolderIcon} alt="Empty folder" />
        </div>
        <span className={classes.message}>{message}</span>
      </div>
    );
  }

  return (
    <div className={classes.EmptyFolderMessage}>
      <div className={classes.emptyFolderIconContainer}>
        <img src={emptyFolderIcon} alt="Empty folder" />
      </div>
      <span className={classes.message}>{message}</span>
    </div>
  );
}
